import utils from '../../util/index';
import CountDown from '../../util/countDown';
/**
 * objName 时间（结束时间、开始时间、服务器时间）在data的对象名
 *
 * 商品秒杀倒计时逻辑
 *
 */
export const seckiller = (objName = 'item', format24 = false) => {
    return {
        data() {
            return {
                countDownTime: 0,
                timeDiff: 0,
                ongoing: 0,
                countDownFn: null,
                isSellout: 0,
                dataTime: {},
            };
        },
        created() {
            window.CountDown = window.CountDown || new CountDown();
        },
        destroyed() {
            window.CountDown.off(this.countDownFn);
        },
        computed: {
            countDownObj() {
                let { seconds, minutes, hours, days } = format24
                    ? utils.formatTime(this.countDownTime)
                    : utils.formatTimeFor48(this.countDownTime);
                seconds = utils.patchPosition(seconds);
                minutes = utils.patchPosition(minutes);
                hours = utils.patchPosition(hours);
                return {
                    days: days,
                    seconds: seconds,
                    minutes: minutes,
                    hours: hours,
                };
            },
        },
        methods: {
            initTimeDown() {
                let dataTarget = this[objName] && this[objName].liveEndTime ? this[objName] : this;
                let { liveEndTime, serverTime, liveStartTime } = dataTarget;
                serverTime = serverTime || this.serverTime;
                if (!serverTime) return;
                if (!liveEndTime) {
                    this.isSellout = 1;
                    this.$emit('stopCounting');
                    return;
                }

                this.dataTime = { liveEndTime, serverTime, liveStartTime };
                if (!this.timeDiff) this.timeDiff = serverTime - new Date().getTime();
                if (liveEndTime && +serverTime < +liveEndTime) {
                    let deviceTime = new Date().getTime();
                    let realTime = deviceTime + this.timeDiff;
                    let countStart = realTime < liveStartTime;
                    this.ongoing = countStart ? 0 : 1;
                    let finalTime = countStart ? liveStartTime : liveEndTime;

                    const remainTime = utils.getRemainTimePlus(finalTime, this.timeDiff);
                    this.countDownTime = remainTime;
                    this.countDownFn = () => {
                        const remainTime = utils.getRemainTimePlus(finalTime, this.timeDiff);
                        this.countDownTime = remainTime;
                        if (remainTime <= 0) {
                            window.CountDown.off(this.countDownFn);
                            // TODO 倒数结束
                            if (countStart) {
                                console.log('进入倒数');
                                // 隐藏
                                this.initTimeDown();
                            } else {
                                this.isSellout = 1;
                                this.timeDownFn && this.timeDownFn();
                                this.$emit('stopCounting');
                            }
                        }
                    };
                    window.CountDown.add(this.countDownFn);
                } else {
                    this.isSellout = 1;
                    this.$emit('stopCounting');
                }
            },
        },
    };
};
